import React from "react";
import styles from "./HeaderImg.scss";

export class HeaderImg extends React.PureComponent {
  render() {
    const { headingAlt, headerText, src, srcSet, position } = this.props;
    return (
      <div className={styles.header}>
        <span className={styles.text}>
          <h2 data-heading-alt>{headingAlt}</h2>
          <h1>{headerText}</h1>
        </span>
        <img className={styles.img} src={src} style={{ objectPosition: position }} srcSet={srcSet} />
      </div>
    );
  }
}
